// frontend/src/components/admin/ResellerTable.js
import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Box,
  CircularProgress,
  Alert,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { adminAPI } from "../../services/api";

const ResellerTable = () => {
  const [resellers, setResellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTopResellers();
  }, []);

  const fetchTopResellers = async () => {
    try {
      setLoading(true);
      const response = await adminAPI.getTopResellers();
      setResellers(response.data.slice(0, 5)); // Get top 5 resellers
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={2}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 1 }}>
        {error}
      </Alert>
    );
  }

  return (
    <Box>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Reseller</TableCell>
            <TableCell align="right">Credits</TableCell>
            <TableCell align="right">Orders</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {resellers.map((reseller) => (
            <TableRow key={reseller.id} hover>
              <TableCell>
                <Typography variant="body2">{reseller.username}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {reseller.email}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="body2">
                  {formatCurrency(reseller.creditBalance)}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Typography variant="body2">{reseller.totalOrders}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
        <Button size="small" onClick={() => navigate("/admin/resellers")}>
          View All Resellers
        </Button>
      </Box>
    </Box>
  );
};

export default ResellerTable;
